import {useEffect, useState} from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {isUndefined} from 'lodash';
import {ApiService} from '@nl/ui';
import FreeSampleService from '@nl/free-sample';

const useFreeSample = () => {
	const {
		LOC_SERVER,
		initialized,
	} = useSelector(
			(state) => ({
				LOC_SERVER: state.config.data.LOC_SERVER,
				initialized: state.client.initialized,
			}),
			shallowEqual,
	);
	const [initFreeSample, setInitFreeSample] = useState(false);

	useEffect(() => {
		if (!isUndefined(LOC_SERVER) && initialized && !initFreeSample) {
			FreeSampleService.init({
				LOC_SERVER,
				apiService: ApiService,
				useCookieCache: true,
				cookieDomain: '.nba.com',
			});
			setInitFreeSample(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [LOC_SERVER, initialized]);

	return initialized;
};

export default useFreeSample;
